import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgxNoGroupsComponent } from '@go-modules/components/no-groups/no-groups.component';
import { NgxZeroStateModule } from '@go-modules/components/zero-state/zero-state.module';

@NgModule({
	declarations: [
		NgxNoGroupsComponent
	],
	imports: [
		CommonModule,
		TranslateModule,
		NgxZeroStateModule
	],
	exports: [
		NgxNoGroupsComponent
	]
})
export class NgxNoGroupsModule {}
